module.exports = __webpack_public_path__ + "img/arrow_up_2.b1a48c54.svg";